/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const YouTubePlayer = ({ youtubeUrl, isIlanDetay }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isShorts, setIsShorts] = useState(false);
  const [videoId, setVideoId] = useState("");

  // Extract YouTube video ID from various formats of YouTube URLs
  useEffect(() => {
    const extractYouTubeId = (url) => {
      if (!url) {
        setVideoId("");
        setIsShorts(false);
        return;
      }

      // Check if it's a Shorts URL
      const shortsRegExp =
        /(?:youtube\.com\/shorts\/|youtube\.com\/shorts\/)([^#&?]*)/;
      const shortsMatch = url.match(shortsRegExp);

      if (shortsMatch && shortsMatch[1].length === 11) {
        setIsShorts(true);
        setVideoId(shortsMatch[1]);
        return;
      }

      // Handle other YouTube URL formats
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      setIsShorts(false);
      setVideoId(match && match[2].length === 11 ? match[2] : "");
    };

    extractYouTubeId(youtubeUrl);
  }, [youtubeUrl]);

  const playVideo = () => {
    setIsPlaying(true);
  };

  return (
    <div className="video-content">
      <div className="container">
        <div className="row">
          <div
            className={isIlanDetay === undefined ? "col-lg-10 offset-lg-1" : ""}
          >
            <div
              className="video-frame"
              style={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                width: "100%",
                margin: "0 auto",
                background: "#000",
              }}
            >
              {!isPlaying ? (
                <>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingBottom: "56.25%", // 16:9 aspect ratio for container
                      overflow: "hidden",
                      background: "#000",
                    }}
                  >
                    <img
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: isShorts ? "auto" : "100%",
                        height: isShorts ? "100%" : "auto",
                        maxWidth: "none",
                      }}
                      src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                      alt="Video thumbnail"
                      onError={(e) => {
                        // Fallback to lower resolution if maxresdefault is not available
                        e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                      }}
                    />
                    <a
                      onClick={playVideo}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 10,
                        background: "rgba(0,0,0,0.6)",
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="fa fa-play"
                        style={{ fontSize: "24px", color: "white" }}
                      ></i>
                    </a>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "56.25%", // 16:9 aspect ratio container
                    overflow: "hidden",
                    background: "#000",
                  }}
                >
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: isShorts ? "50%" : 0,
                      transform: isShorts ? "translateX(-50%)" : "none",
                      width: isShorts ? "100%" : "100%", // Wider for Shorts to show controls
                      height: "100%",
                      border: "none",
                    }}
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

YouTubePlayer.propTypes = {
  youtubeUrl: PropTypes.string.isRequired,
};

export default YouTubePlayer;
